import { FormElement, InputText } from 'mailup-web-components'
import { senderConfigState } from 'Pages/Task/recoil/state/task'

import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

const InputSenderName = () => {
  const intl = useIntl()
  const [{ SenderName, senderNameIsDiry, CustomSender }, setSenderConfig] =
    useRecoilState(senderConfigState)

  const handleChangeName = (e) => {
    setSenderConfig((prev) => ({
      ...prev,
      IsDiry: true,
      SenderName: e.target.value,
      senderNameIsDiry: true
    }))
  }

  return (
    <div>
      <FormElement
        required
        label={
          CustomSender
            ? intl.formatMessage({
                id: 'Load.EmailSendingWizard.DefaultSenderNameLabel'
              })
            : intl.formatMessage({ id: 'Load.Common.SenderNameLabel' })
        }
        labelHelp={
          CustomSender
            ? intl.formatMessage({
                id: 'Load.EmailSendingWizard.SenderNameDefaultTooltip'
              })
            : undefined
        }
        feedback={
          !SenderName && senderNameIsDiry
            ? intl.formatMessage({
                id: 'Load.EmailSendingWizard.SenderNameRequired'
              })
            : undefined
        }
      >
        <InputText
          placeholder={SenderName}
          value={SenderName}
          onChange={handleChangeName}
          data-mu-test='input-SenderName'
          variant={SenderName === '' ? 'danger' : null}
        />
      </FormElement>
    </div>
  )
}

export default InputSenderName
